import { render, staticRenderFns } from "./Accordian.vue?vue&type=template&id=23cfe59a"
import script from "./Accordian.vue?vue&type=script&lang=js"
export * from "./Accordian.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports